import { useLocation } from "react-router-dom";

function useUrlQueryParams() {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  // Extract "group" and "page" parameters
  const group = searchParams.get("group");
  const page = searchParams.get("page");
  const form = searchParams.get("form");
  const document = searchParams.get("document");
  const redirectUrl = searchParams.get("redirectUrl");
  const pfilters = searchParams.get("pfilters");

  return { group, page, form, document, redirectUrl, pfilters };
}

export default useUrlQueryParams;
